<!-- Mobile Header - responsive styling via Tailwind classes -->
<div class="mobile-header px-4 py-3 max-sm:px-3 max-sm:py-2.5"
     [class.impersonating]="isImpersonationAllowed && isImpersonating()">
  <button
    class="hamburger-btn"
    type="button"
    (click)="toggleSidebar()"
    aria-label="Toggle sidebar menu">
    <i class="pi pi-bars"></i>
  </button>
  <div class="mobile-logo">
    <img src="logo.svg" alt="Plymouth Rock" class="h-7 max-sm:h-6" />
  </div>
  <div class="mobile-user">
    @if (isImpersonationAllowed && isImpersonating()) {
      <i class="pi pi-eye text-amber-300"></i>
      <span class="mobile-user-name max-sm:hidden text-amber-300">{{ impersonatedName() }}</span>
      <p-button
        [text]="true"
        [rounded]="true"
        severity="warn"
        icon="pi pi-times-circle"
        size="small"
        (onClick)="stopImpersonating()" />
    } @else {
      <i class="pi pi-user"></i>
      <span class="mobile-user-name max-sm:hidden">{{ userName }}</span>
      <i class="pi pi-chevron-down"></i>
    }
  </div>
</div>
